import axios from "axios";
import Cookies from "js-cookie";

const dev = "http://172.16.101.223:8000/api/";
const production = "https://webapps.coperdia.com.br/app_colaborador/api/";

const api = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? dev : production,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

api.interceptors.request.use(
  async function (config) {
    const session = Cookies.get("web_colaborador");

    if (session) {
      const ses = JSON.parse(session);
      config.headers.Authorization = "Bearer " + ses.token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
